import mixpanel from 'mixpanel-browser';

const API_TOKEN = process.env.NX_MIXPANEL_PROJECT_TOKEN;

mixpanel.init(API_TOKEN, {
  debug: process.env.NX_ENV === 'development',
  persistence: 'localStorage',
});

function track(...args: Parameters<typeof mixpanel.track>) {
  if (API_TOKEN) {
    mixpanel.track(...args);
  }
}

function identify(...args: Parameters<typeof mixpanel.identify>) {
  if (API_TOKEN) {
    mixpanel.identify(...args);
  }
}

function reset() {
  if (API_TOKEN) {
    mixpanel.reset();
  }
}

function trackPageView() {
  if (API_TOKEN) {
    mixpanel.track_pageview();
  }
}

export const analytics = {
  identify,
  reset,
  trackPageView,
  track,
};
